module.exports = __webpack_public_path__ + "img/MS_WeaponSword000.205b4a6c.png";